import { Typography } from "@mui/material"
import { Box } from "@mui/system"

function EscribenosTabComponent() {
	return (
		<div className="content">
			{" "}
			<Box>
				<span>WIP</span>
			</Box>
			<Typography variant="h5">
				Accede a nuestro discord y dejanos un mensaje!
			</Typography>
			<iframe
				src="https://discord.com/widget?id=1018949341135773736&theme=dark"
				width="500"
				height="300"
				allowtransparency="true"
				frameborder="0"
				sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
			></iframe>
		</div>
	)
}

export default EscribenosTabComponent
